module.exports = __webpack_public_path__ + "img/coin-setting.02fb63f2.svg";